
























































































































































































































































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
import TablaCajaChica from "@/components/cajaChicas/Tabla.vue";
import FormularioCajaChica from "@/components/cajaChicas/Formulario.vue";
import { DataFormularioCajaChica } from "@/typings/components/cajaChicas/formulario";
import DialogoExito from "@/components/DialogoExito.vue";
import InfoCajaChica from "@/components/cajaChicas/Info.vue";
import ExportarExcel from "@/components/cajaChicas/ExportarExcel.vue";
import ExportarPdf from "@/components/cajaChicas/ExportarPdf.vue";
import CargarExcelCajaChicas from "@/components/cajaChicas/CargarExcel.vue";
import MensajeEliminar from "@/components/MensajeEliminar.vue";
import { CajaChica, CajaChicas } from "@/typings/store/plugins/easyFirestore/cajaChicas";

type MetricaTarjeta = "saldo" | "ingresos" | "egresos" | "registros" | "sinComprobante" | "cobertura";

interface MetricasPeriodo {
  saldo: number;
  ingresos: number;
  egresos: number;
  registros: number;
  sinComprobante: number;
  cobertura: number;
}

interface ComparacionTarjeta {
  contexto: string;
  titulo: string;
  actual: number;
  anterior: number;
  esMoneda: boolean;
  esPorcentaje: boolean;
  periodoActual: string;
  periodoAnterior: string;
  variacion: number | null;
  favorableSiSube: boolean;
}
import { idtify } from "@/helpers/string";
import "@/helpers/extensions";

const routeGuard = (vm: Vue): boolean => {
  const permisos = vm.getUsuario?.permisos;
  if (permisos && permisos["cajaChicas"]) return true;
  const rutas = vm.getRutasUsuario;
  if (rutas.length > 0) {
    const to = rutas[0].to;
    if (to && vm.$route.name !== to.name) {
      vm.$router.replace(to);
    }
    return false;
  }
  if (vm.$route.name !== "inicio") {
    vm.$router.replace({ name: "inicio" });
  }
  return false;
};

@Component({
  computed: mapGetters({
    getUsuarios: "usuarios/get",
    getCajaChicas: "cajaChicas/get",
    getArrayUsuarios: "usuarios/getArray",
    getUsuario: "usuario/get",
    getRutas: "rutas/get",
    getRutasUsuario: "usuario/getRutas",
    getArrayCajaChicas: "cajaChicas/getArray",
  }),
  methods: mapActions({
    setCajaChica: "cajaChicas/set",
    deleteCajaChica: "cajaChicas/delete",
    insertBatchCajaChicas: "cajaChicas/insertBatch",
    setArchivo: "archivos/set",
    deleteArchivo: "archivos/delete",
  }),
  beforeRouteEnter(to, from, next) {
    next(routeGuard);
  },
  components: {
    DialogoExito,
    TablaCajaChica,
    FormularioCajaChica,
    InfoCajaChica,
    MensajeEliminar,
    CargarExcelCajaChicas,
    ExportarExcel,
    ExportarPdf,
  },
})
export default class VistaCajaChicas extends Vue {
  created(): void {
    if (!routeGuard(this)) return;
  }

  cargando = false;
  dialogoExito = { model: false, texto: "", icono: "" };
  search = "";
  cajaChica: CajaChica | null = null;
  dialogoInfo = false;
  dialogoFormulario = false;
  dialogoEliminar = false;
  dialogoCargarExcel = false;
  resumenGeneralAbierto = false;
  dialogoTarjeta = false;
  tarjetaActiva: MetricaTarjeta | null = null;
  tarjetaOrigen: "periodo" | "anio" = "periodo";
  periodoSeleccionado: { value: string; label: string } | null = null;
  private defaultPeriodoAsignado = false;
  snackbarErrorFoto = { show: false, text: "" };

  async onCargaExcel(docs: CajaChica[]): Promise<void> {
    try {
      const ahora = new Date().format("DD-MM-YYYY HH:mm");
      const conAutor = docs.map((doc) => ({
        ...doc,
        creadoPor: this.nombreUsuario,
        creadoEn: ahora,
      }));
      await this.$store.dispatch("cajaChicas/insertBatch", conAutor);
      this.dialogoCargarExcel = false;
      this.$store.commit("snackbar/set", {
        text: `${docs.length} registro(s) importados correctamente.`,
        color: "success",
      });
    } catch (e) {
      this.$store.commit("snackbar/set", {
        text: "Error al guardar los registros importados.",
        color: "error",
      });
    }
  }

  onErrorFotoPdf(): void {
    this.snackbarErrorFoto = {
      show: true,
      text: "No se pudo convertir la foto a PDF. Intente con otra imagen o cargue un PDF directamente.",
    };
  }

  get items(): Array<CajaChica> {
    return this.itemsEnPeriodo(this.periodoSeleccionado?.value ?? null);
  }

  itemsEnPeriodo(clave: string | null): Array<CajaChica> {
    const registros = [...this.getArrayCajaChicas];
    const lista = !clave
      ? registros
      : registros.filter((item) => this.coincidePeriodo(item, clave));
    return lista.sort((a, b) => b.numero - a.numero);
  }

  coincidePeriodo(item: CajaChica, clave: string): boolean {
    const periodo = this.periodoDe(item);
    if (!periodo) return false;
    const partes = periodo.split("-");
    const seleccion = clave.split("-");
    if (partes.length !== 3 || seleccion.length !== 3) return false;
    const [, mes, anio] = partes;
    const [, mesSel, anioSel] = seleccion;
    return mes.padStart(2, "0") === mesSel.padStart(2, "0") && anio === anioSel;
  }

  get itemsSinFiltrar(): Array<CajaChica> {
    return [...this.getArrayCajaChicas];
  }

  get cajaChicas(): CajaChicas {
    return this.getCajaChicas;
  }

  get tipoUsuario(): string {
    return (this.getUsuario && this.getUsuario.tipo) ? String(this.getUsuario.tipo) : "";
  }

  get nombreUsuario(): string {
    const usuario = this.getUsuario;
    if (!usuario) return "Usuario";
    return usuario.nombre || usuario.email || "Usuario";
  }

  marcarAutor(doc: CajaChica, previo: CajaChica | null): void {
    const ahora = new Date().format("DD-MM-YYYY HH:mm");
    if (previo?.id) {
      // Los registros anteriores al seguimiento no tienen autor: no se copia undefined,
      // que Firestore rechaza al guardar.
      if (previo.creadoPor) doc.creadoPor = previo.creadoPor;
      else delete doc.creadoPor;
      if (previo.creadoEn) doc.creadoEn = previo.creadoEn;
      else delete doc.creadoEn;
      doc.editadoPor = this.nombreUsuario;
      doc.editadoEn = ahora;
      return;
    }
    doc.creadoPor = this.nombreUsuario;
    doc.creadoEn = ahora;
  }

  get totalItems(): number { return this.items.length; }
  get totalItemsSinFiltrar(): number { return this.itemsSinFiltrar.length; }

  /** Saldo total en resumen general = total ingresos - total egresos (sin filtrar por periodo). */
  get totalSaldo(): number {
    return this.totalIngresosSinFiltrar - this.totalEgresosSinFiltrar;
  }

  /** Ingresos del periodo = ABONAR + SALDO PERIODO ANTERIOR (se suman los saldos que entran al periodo). */
  get totalIngresos(): number {
    return this.items
      .filter(
        (item) => item.accion === "ABONAR" || item.accion === "SALDO PERIODO ANTERIOR"
      )
      .reduce((total, item) => total + parseInt(String(item.ingreso), 10), 0);
  }

  /** Total ingresos (todos los registros) = solo ABONAR. */
  get totalIngresosSinFiltrar(): number {
    return this.itemsSinFiltrar
      .filter((item) => item.accion === "ABONAR")
      .reduce((total, item) => total + parseInt(String(item.ingreso), 10), 0);
  }

  get totalEgresosSinFiltrar(): number {
    return this.itemsSinFiltrar
      .filter((item) => item.accion !== "SALDO PERIODO ANTERIOR")
      .reduce((total, item) => total + parseInt(String(item.egreso), 10), 0);
  }

  get totalEgresos(): number {
    return this.items
      .filter((item) => item.accion !== "SALDO PERIODO ANTERIOR")
      .reduce((total, item) => total + parseInt(String(item.egreso), 10), 0);
  }

  get total(): number {
    return this.totalIngresos - this.totalEgresos;
  }

  /** Textos (accion/documento) que NO deben contarse como "movimiento" a efectos de comprobante. */
  private readonly TEXTOS_SALDOS_EXCLUIDOS_COMPROBANTE = ["SALDO PERIODO ANTERIOR", "SALDO INICIAL"];

  private normalizarTexto(input: string | null | undefined): string {
    return (input ?? "").trim().toUpperCase();
  }

  private esSaldoExcluidoComprobante(item: CajaChica): boolean {
    const accion = this.normalizarTexto(item.accion);
    const documento = this.normalizarTexto(item.documento);
    return (
      this.TEXTOS_SALDOS_EXCLUIDOS_COMPROBANTE.includes(accion) ||
      this.TEXTOS_SALDOS_EXCLUIDOS_COMPROBANTE.includes(documento)
    );
  }

  get movimientosSinComprobanteGeneral(): number {
    return this.itemsSinFiltrar.filter((item) => {
      if (this.esSaldoExcluidoComprobante(item)) return false;
      const arch = item.archivo;
      return !arch || typeof arch !== "object" || Object.keys(arch).length === 0;
    }).length;
  }

  get movimientosSinComprobantePeriodo(): number {
    return this.items.filter((item) => {
      if (this.esSaldoExcluidoComprobante(item)) return false;
      const arch = item.archivo;
      return !arch || typeof arch !== "object" || Object.keys(arch).length === 0;
    }).length;
  }

  get totalMovimientosGeneral(): number {
    return this.itemsSinFiltrar.filter(
      (item) => !this.esSaldoExcluidoComprobante(item)
    ).length;
  }

  get totalMovimientosPeriodo(): number {
    return this.items.filter(
      (item) => !this.esSaldoExcluidoComprobante(item)
    ).length;
  }

  get porcentajeComprobantesGeneral(): number {
    const total = this.totalMovimientosGeneral;
    if (total === 0) return 0;
    const conComprobante = total - this.movimientosSinComprobanteGeneral;
    return Math.round((conComprobante / total) * 100);
  }

  get porcentajeComprobantesPeriodo(): number {
    const total = this.totalMovimientosPeriodo;
    if (total === 0) return 0;
    const conComprobante = total - this.movimientosSinComprobantePeriodo;
    return Math.round((conComprobante / total) * 100);
  }

  get periodoYAnioTexto(): string {
    const p = this.periodoSeleccionado;
    if (!p || !p.label) return "Todos los periodos";
    const partes = p.label.split("-");
    if (partes.length !== 3) return p.label;
    const mesNum = parseInt(partes[1], 10);
    const anio = partes[2];
    const meses = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
    const mesNombre = meses[mesNum - 1] || partes[1];
    return `${mesNombre} ${anio}`;
  }

  get periodoActualValue(): string {
    const now = new Date();
    const mes = String(now.getMonth() + 1).padStart(2, "0");
    const anio = now.getFullYear();
    return `01-${mes}-${anio}`;
  }

  periodoDe(item: CajaChica): string {
    if (typeof item.periodo === "string" && item.periodo.trim()) {
      return item.periodo.trim();
    }
    const fecha = item.fecha;
    if (typeof fecha !== "string") return "";
    const partes = fecha.split("-");
    if (partes.length !== 3) return "";
    const [, mes, anio] = partes;
    if (!mes || !anio || anio.length !== 4) return "";
    return `01-${mes.padStart(2, "0")}-${anio}`;
  }

  get selectPeriodo(): Array<{ value: string; label: string }> {
    const periodos = this.getArrayCajaChicas
      .map((c) => this.periodoDe(c))
      .filter((p) => p.length > 0);
    const periodosUnicos = new Map<string, { value: string; label: string }>();
    periodos.forEach((periodo) => {
      const partes = periodo.split("-");
      if (partes.length !== 3) return;
      const [dia, mes, anio] = partes;
      const clave = `${dia}-${mes}-${anio}`;
      if (!periodosUnicos.has(clave)) {
        periodosUnicos.set(clave, { value: clave, label: `01-${mes}-${anio}` });
      }
    });
    const now = new Date();
    const mesActual = String(now.getMonth() + 1).padStart(2, "0");
    const anioActual = now.getFullYear();
    const claveActual = `01-${mesActual}-${anioActual}`;
    if (!periodosUnicos.has(claveActual)) {
      periodosUnicos.set(claveActual, { value: claveActual, label: claveActual });
    }
    return Array.from(periodosUnicos.values()).sort((a, b) => {
      const [, mesA, anioA] = a.value.split("-");
      const [, mesB, anioB] = b.value.split("-");
      return new Date(`${anioB}-${mesB}-01`).getTime() - new Date(`${anioA}-${mesA}-01`).getTime();
    });
  }

  @Watch("selectPeriodo", { immediate: true })
  aplicarPeriodoActualPorDefecto(): void {
    if (this.defaultPeriodoAsignado || this.periodoSeleccionado != null) return;
    const lista = this.selectPeriodo;
    if (lista.length === 0) return;
    const actual = lista.find((p) => p.value === this.periodoActualValue);
    if (actual) {
      this.periodoSeleccionado = actual;
      this.defaultPeriodoAsignado = true;
    }
  }

  clickItem(val: { id: string } | null): void {
    this.cajaChica = val ? this.cajaChicas[val.id] : null;
  }

  clickPlus(): void {
    this.cajaChica = null;
    this.dialogoFormulario = true;
  }

  abrirTarjeta(id: MetricaTarjeta, origen: "periodo" | "anio" = "periodo"): void {
    this.tarjetaActiva = id;
    this.tarjetaOrigen = origen;
    this.dialogoTarjeta = true;
  }

  metricasDe(lista: Array<CajaChica>): MetricasPeriodo {
    const ingresos = lista
      .filter((item) => item.accion === "ABONAR" || item.accion === "SALDO PERIODO ANTERIOR")
      .reduce((total, item) => total + parseInt(String(item.ingreso), 10), 0);
    const egresos = lista
      .filter((item) => item.accion !== "SALDO PERIODO ANTERIOR")
      .reduce((total, item) => total + parseInt(String(item.egreso), 10), 0);
    const movimientos = lista.filter((item) => !this.esSaldoExcluidoComprobante(item));
    const sinComprobante = movimientos.filter((item) => {
      const arch = item.archivo;
      return !arch || typeof arch !== "object" || Object.keys(arch).length === 0;
    }).length;
    const cobertura = movimientos.length === 0
      ? 0
      : Math.round(((movimientos.length - sinComprobante) / movimientos.length) * 100);
    return {
      saldo: ingresos - egresos,
      ingresos,
      egresos,
      registros: lista.length,
      sinComprobante,
      cobertura,
    };
  }

  periodoAnteriorClave(clave: string): string {
    const partes = clave.split("-");
    let mes = parseInt(partes[1], 10);
    let anio = parseInt(partes[2], 10);
    mes -= 1;
    if (mes < 1) {
      mes = 12;
      anio -= 1;
    }
    return `01-${String(mes).padStart(2, "0")}-${anio}`;
  }

  nombrePeriodo(clave: string): string {
    const partes = clave.split("-");
    if (partes.length !== 3) return clave;
    const mesNum = parseInt(partes[1], 10);
    const meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    return `${meses[mesNum - 1] || partes[1]} ${partes[2]}`;
  }

  porcentajeVariacion(actual: number, anterior: number): number | null {
    if (anterior === 0) return actual === 0 ? 0 : null;
    return Math.round(((actual - anterior) / Math.abs(anterior)) * 1000) / 10;
  }

  itemsAcumulados(anio: number, mesHasta: number): Array<CajaChica> {
    const registros = this.getArrayCajaChicas || [];
    return registros.filter((item) => {
      const periodo = this.periodoDe(item);
      const partes = periodo.split("-");
      if (partes.length !== 3) return false;
      const mes = parseInt(partes[1], 10);
      const anioItem = parseInt(partes[2], 10);
      return anioItem === anio && mes >= 1 && mes <= mesHasta;
    });
  }

  nombreMes(mes: number): string {
    const meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    return meses[mes - 1] || String(mes);
  }

  armarComparacion(id: MetricaTarjeta, actual: number, anterior: number, periodoActual: string, periodoAnterior: string, contexto: string, titulos: Record<MetricaTarjeta, string>): ComparacionTarjeta {
    return {
      contexto,
      titulo: titulos[id],
      actual,
      anterior,
      esMoneda: id === "saldo" || id === "ingresos" || id === "egresos",
      esPorcentaje: id === "cobertura",
      periodoActual,
      periodoAnterior,
      variacion: this.porcentajeVariacion(actual, anterior),
      favorableSiSube: id !== "egresos" && id !== "sinComprobante",
    };
  }

  get comparacionTarjeta(): ComparacionTarjeta | null {
    const id = this.tarjetaActiva;
    if (!id) return null;
    if (this.tarjetaOrigen === "anio") {
      const ahora = new Date();
      const mes = ahora.getMonth() + 1;
      const anio = ahora.getFullYear();
      const actual = this.metricasDe(this.itemsAcumulados(anio, mes))[id];
      const anterior = this.metricasDe(this.itemsAcumulados(anio - 1, mes))[id];
      const rango = `Enero – ${this.nombreMes(mes)}`;
      return this.armarComparacion(
        id,
        actual,
        anterior,
        `${rango} ${anio}`,
        `${rango} ${anio - 1}`,
        "Acumulado del año",
        {
          saldo: "Saldo acumulado",
          ingresos: "Ingresos acumulados",
          egresos: "Egresos acumulados",
          registros: "Registros acumulados",
          sinComprobante: "Sin comprobante",
          cobertura: "Cobertura de comprobantes",
        }
      );
    }
    const clave = this.periodoSeleccionado?.value;
    if (!clave) return null;
    const anteriorClave = this.periodoAnteriorClave(clave);
    const actual = this.metricasDe(this.itemsEnPeriodo(clave))[id];
    const anterior = this.metricasDe(this.itemsEnPeriodo(anteriorClave))[id];
    return this.armarComparacion(
      id,
      actual,
      anterior,
      this.nombrePeriodo(clave),
      this.nombrePeriodo(anteriorClave),
      "Periodo anterior",
      {
        saldo: "Saldo del periodo",
        ingresos: "Ingresos del periodo",
        egresos: "Egresos del periodo",
        registros: "Registros del periodo",
        sinComprobante: "Sin comprobante",
        cobertura: "Cobertura de comprobantes",
      }
    );
  }

  formatearMetrica(valor: number, comparacion: ComparacionTarjeta): string {
    if (comparacion.esMoneda) return valor.toCurrency({ symbol: "$" });
    if (comparacion.esPorcentaje) return `${valor}%`;
    return String(valor);
  }

  textoVariacion(variacion: number | null): string {
    if (variacion === null) return "Sin base";
    const signo = variacion > 0 ? "+" : "";
    return `${signo}${variacion}%`;
  }

  claseVariacion(comparacion: ComparacionTarjeta): string {
    const variacion = comparacion.variacion;
    if (variacion === null || variacion === 0) return "caja-variacion__neutro";
    const sube = variacion > 0;
    const favorable = comparacion.favorableSiSube ? sube : !sube;
    return favorable ? "caja-variacion__favorable" : "caja-variacion__desfavorable";
  }

  async clickGuardar(data: DataFormularioCajaChica): Promise<void> {
    this.cargando = true;
    const doc = data.doc;
    const archivo = data.archivo;
    const borrar = data.borrar;
    for (const key in archivo) {
      if (archivo[key].file) {
        const docArch = archivo[key];
        const res = await this.setArchivo(docArch);
        if (res && res.url) {
          this.$set(archivo, idtify(res.id), res);
        }
      }
    }
    for (const key in borrar) {
      if (borrar[key]) {
        const docBorrar = borrar[key];
        await this.deleteArchivo(docBorrar.id);
      }
    }
    doc.archivo = archivo;
    this.marcarAutor(doc, doc.id ? this.cajaChica : null);
    await this.setCajaChica(doc);
    if (doc.id != this.cajaChica?.id) {
      this.dialogoExito = { model: true, texto: "¡Registro Caja Chica creado con éxito!", icono: require("../assets/icons/double-check-duo.svg") };
    }
    if (doc.id == this.cajaChica?.id) {
      this.dialogoExito = { model: true, texto: "¡Registro Caja Chica editado con éxito!", icono: require("../assets/icons/editar.svg") };
      this.cajaChica = doc;
    }
    this.cerrarDialogoFormulario();
    this.cargando = false;
  }

  cerrarDialogoExito(): void {
    this.dialogoExito = { model: false, texto: "", icono: "" };
  }

  clickEliminar(): void {
    const cajaChica = this.cajaChica;
    if (!cajaChica?.id) return;
    this.deleteCajaChica(cajaChica.id);
    this.cajaChica = null;
    this.cerrarDialogoEliminar();
  }

  abrirDialogoInfo(cajaChica: CajaChica): void {
    if (!cajaChica.id) return;
    const doc = this.cajaChicas[cajaChica.id];
    if (doc) {
      this.cajaChica = doc;
      this.dialogoInfo = true;
    }
  }

  cerrarDialogoInfo(): void {
    this.dialogoInfo = false;
    this.cajaChica = null;
  }

  abrirDialogoFormulario(cajaChica: CajaChica): void {
    if (!cajaChica.id) return;
    const doc = this.cajaChicas[cajaChica.id];
    if (doc) {
      this.cajaChica = doc;
      this.dialogoFormulario = true;
    }
  }

  abrirDialogoEliminar(cajaChica: CajaChica): void {
    if (!cajaChica.id) return;
    const doc = this.cajaChicas[cajaChica.id];
    if (doc) {
      this.dialogoEliminar = true;
      this.cajaChica = doc;
    }
  }

  cerrarDialogoEliminar(): void {
    this.dialogoEliminar = false;
    this.cajaChica = null;
  }

  montoEliminar(valor: string | number | undefined | null): string {
    if (valor === undefined || valor === null || valor === "") return "-";
    const num = typeof valor === "string" ? parseFloat(valor.replace(/\./g, "").replace(",", ".")) : Number(valor);
    if (Number.isNaN(num) || num === 0) return "-";
    return "$ " + Math.round(num).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  cerrarDialogoFormulario(): void {
    this.dialogoFormulario = false;
    this.cajaChica = null;
  }
}
